export enum LocaleE {
  en_US = 'en-US',
}
